module.exports = __webpack_public_path__ + "static/media/settings-dropdown-arrow-up.4d68007a.svg";